import { Button } from '@/components/ui/button'
import { Logout } from '@mui/icons-material'
import { Logo, PageContainer, Sidebar } from '../../components'
import { useAuth } from '../../hooks'

export default function SectionSidebar() {
  const { logout } = useAuth()

  return (
    <aside className="shadow-primary hidden md:block shadow-sm py-8 h-full w-[240px]">
      <PageContainer className="h-full flex flex-col">
        <Logo />

        <div className="w-full flex-1 mt-8">
          <Sidebar />
        </div>

        <footer className="w-full">
          <Button
            onClick={logout}
            variant="secondary"
            className="!w-full !gap-4 !justify-start rounded-lg py-5"
          >
            <Logout className="text-primary" />
            <span>Sair</span>
          </Button>
        </footer>
      </PageContainer>
    </aside>
  )
}
